import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { ConverterService, OccEndpointsService } from '@spartacus/core';
import { OCC_ENDPOINTS, OccTrackingPickup } from '@tracking/const';
import { TRACKING_PICKUP_NORMALIZER } from '@tracking/utils';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OccTrackingPickupService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private converterService: ConverterService,
  ) {}

  load(orderGuid: string): Observable<OccTrackingPickup> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.trackingPickup, {
      urlParams: { orderGuid },
    });

    return this.http
      .get<OccTrackingPickup>(url, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.trackingPickup),
      })
      .pipe(this.converterService.pipeable(TRACKING_PICKUP_NORMALIZER));
  }
}
